import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import rootReducer from "../reducer";
import { persistStore, persistReducer, createMigrate } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { productsApi } from './api/productsApi';
import { setupListeners } from '@reduxjs/toolkit/query';


const migrations = {
  0: (state) => {

    try {
      const categoryList = state?.category?.categories?.categoryList;

      if (categoryList && Array.isArray(categoryList)) {
        return {
          ...state,
          category: {
            ...state.category,
            categories: {
              ...state.category.categories,
              categoryList: categoryList.map(cat => ({
                ...cat,
                groupCategory: cat.groupCategory || []
              }))
            }
          }
        };
      }
    } catch (error) {
      console.warn('Migration error:', error);
    }

    return state;
  }
};

const persistConfig = {
  key: "root",
  storage,
  version: 1,
  migrate: createMigrate(migrations, { debug: false }),
  blacklist: [productsApi.reducerPath],
};

const middleware = [thunk];
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Use configureStore to easily add RTK Query middleware
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(middleware, [productsApi.middleware]),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store);

// optional: enable refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export default store;